export const types = {
    SET_AUTH:"SET_AUTH",
};
